export const getEnvEndpoints = () => {
  const isUpgrade = Boolean(process.env.REACT_APP_SERVER_UPGRADE && process.env.REACT_APP_SERVER_UPGRADE === "1");
  if (isUpgrade) {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL_NEW || 'https://management-idbf.inexture.in',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2_NEW || 'https://elasticsearch-idbf.inexture.in/',
      REACT_APP_ESUSERNAME: process.env.REACT_APP_ESUSERNAME_NEW || 'elastic',
      REACT_APP_ESPSW: process.env.REACT_APP_ESPSW_NEW || 'oZY_6AnIbA9WD*-94LU9',
    }
  } else {
    return {
      REACT_APP_BASE_MEDIA_URL: process.env.REACT_APP_BASE_MEDIA_URL || 'https://management.100procentlokaal.be',
      REACT_APP_BASE_MEDIA_URL2: process.env.REACT_APP_BASE_MEDIA_URL2 || 'https://elasticsearch.100procentlokaal.be/',
      REACT_APP_ESUSERNAME: process.env.REACT_APP_ESUSERNAME || 'ashish',
      REACT_APP_ESPSW: process.env.REACT_APP_ESPSW || 'QWi7RhJmByGuVmmnZng4',
    }
  }
};
